const LOYALTY_TYPES = ['ReachedTier', 'ReachedMilestone'];

export default LOYALTY_TYPES;
